/* Keep native details as the fallback; enhance height changes when motion is welcome. */
(() => {
  if (window.aoFaqInitialized) return;
  window.aoFaqInitialized = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => document.querySelectorAll('.ao-faq-page').forEach(root => {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    root.querySelectorAll('details').forEach(details => {
      const summary = details.querySelector('summary');
      const answer = details.querySelector('.ao-faq__answer');
      let animation;
      let targetOpen = details.open;
      summary.addEventListener('click', event => {
        if (reducedMotion.matches || !details.animate) return;
        event.preventDefault();
        const startHeight = details.getBoundingClientRect().height;
        targetOpen = animation ? !targetOpen : !details.open;
        if (animation) {
          animation.onfinish = null;
          animation.cancel();
        }
        details.style.height = `${startHeight}px`;
        details.style.overflow = 'hidden';
        details.open = true;
        details.dataset.expanding = String(targetOpen);
        summary.setAttribute('aria-expanded', String(targetOpen));
        const border = parseFloat(getComputedStyle(details).borderBottomWidth) || 0;
        const endHeight = summary.getBoundingClientRect().height + border +
          (targetOpen ? answer.getBoundingClientRect().height : 0);
        animation = details.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: 280, easing: 'cubic-bezier(.25,.8,.25,1)' }
        );
        animation.onfinish = () => {
          details.open = targetOpen;
          details.style.height = '';
          details.style.overflow = '';
          delete details.dataset.expanding;
          summary.removeAttribute('aria-expanded');
          animation = null;
        };
      });
    });
    root.querySelectorAll('.ao-faq__nav a').forEach(link => {
      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
        history.pushState(null, '', link.hash);
        const heading = target.querySelector('h2');
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      });
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
